export function getRealtimeWebRTCAdapter() {
  return {
    RTCPeerConnection: globalThis.RTCPeerConnection,
    RTCSessionDescription: globalThis.RTCSessionDescription,
    mediaDevices: globalThis.navigator?.mediaDevices,
    isNative: false,
  };
}

export async function configureNativeRealtimeAudio() {}

export async function restoreNativeRealtimeAudio() {}
